import React from 'react';

import { CssBaseline } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import PublicHeader from '../components/PublicHeader.component';
import PublicFooter from '../components/PublicFooter.component';
import AuthenticationPanel from '../../../authentication/components/public/AuthenticationPanel.component';

interface PublicLayoutProps {
  children?: React.ReactNode;
}

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: '#fff',
  },
  // Le `main` ne borne pas la largeur : c'est à chaque page de décider, parce qu'une bande de
  // couleur pleine largeur ne peut pas naître dans un conteneur déjà centré. Les pages qui veulent
  // une colonne la posent elles-mêmes, comme le fait `EditorialBand`.
  main: {
    flex: 1,
    width: '100%',
  },
});

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CssBaseline />
      <PublicHeader />
      <main className={classes.main}>{children}</main>
      <AuthenticationPanel />
      <PublicFooter />
    </div>
  );
};

export default PublicLayout;
